// start:ng42.barrel
import './multi-person-picker-popup.controller';
// end:ng42.barrel

